module.exports = __webpack_public_path__ + "img/nav-right-with-contact-toolbar-ford.5aafe82e.png";